import React from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
/**
 * Label para Textos
 * @param {string} id da chave de tradução do arquivo messages-XX.json
 * @param {string} text do corpo do Label
 * @param {string} values JSON das mensagens traduzidas com parâmetros ex: Hello, {nome}
 * @author Fábio Sartori
 * @copyright 2019/06
 */
const TextLabel = props => <FormattedMessage {...props} />;
export default TextLabel;

TextLabel.propTypes = {
    id: PropTypes.string.isRequired,
    text: PropTypes.string,
    values: PropTypes.object
};
